import pl from "@locales/ai_notes/pl.json";
import en from "@locales/ai_notes/en.json";

export default {
  pl: pl,
  en: en,
};
